// @ts-nocheck

import { type RegulationMessageState } from '../states/regulation';
import { RegulationActionTypes } from '../types/actions/regulation';

type SetRealityCheckActionProps = {
  message: RegulationMessageState;
};
export const setRealityCheckMessage = ({ message }: SetRealityCheckActionProps) => ({
  type: RegulationActionTypes.SET_REALITY_CHECK_MESSAGE,
  payload: {
    message,
  },
});

export const dismissRealityCheckMessage = () => ({
  type: RegulationActionTypes.DISMISS_REALITY_CHECK_MESSAGE,
});
